import styled from 'styled-components';

export const HeaderContainer = styled.div`
  padding-right: ${({ theme }) => theme.spacing.m};
  padding-left: ${({ theme }) => theme.spacing.s};
  padding-top: ${({ theme }) => theme.spacing.sm};
  padding-bottom: ${({ theme }) => theme.spacing.sm};
  background-color: ${({ theme }) => theme.colors.darkBlue};
`;

export const HeaderDefaultContent = styled.div`
  display: flex;
  align-items: center;
`;

export const BackArrowContainer = styled.div`
  flex: 1;
`;
export const BackArrowButton = styled.button`
  width: ${({ theme }) => theme.spacing.l};
  height: ${({ theme }) => theme.spacing.l};
  background: none;
  border: none;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex: 3;
  justify-content: space-evenly;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0 ${({ theme }) => theme.spacing.xm};
`;

export const NotificationsBellContainer = styled.div`
  width: 28px;
  height: 28px;
`;

export const AvatarContainer = styled.button`
  border: none;
  background-color: transparent;
  padding: 0;
  width: ${({ theme }) => theme.spacing.l};
  height: ${({ theme }) => theme.spacing.l};
`;
